import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { MuiBox, MuiTypography } from "../../../../../components";
import { ParticipantDetailsCardTypes } from "../../../modelsAndSchemas/Models";
import { ManageParticipantsInfoCardStyle } from "../ManageParticipantsInfo.style";

interface ManageParticipantsInfoCardProps {
  type: ParticipantDetailsCardTypes;
  count: number;
  onCardClick: () => void;
  header: string;
  label: string;
  icon: string;
}

export const ManageParticipantsInfoCard = ({
  icon,
  header,
  label,
  count,
  type,
  onCardClick,
}: ManageParticipantsInfoCardProps) => {
  return (
    <ManageParticipantsInfoCardStyle onClick={onCardClick}>
      <MuiBox className={`participant-info-card participant-info-card-${type}`}>
        <MuiBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          data-testid="participant-info-card"
        >
          <MuiTypography
            className="participant-info-card-header"
            variant="h3SemiBold"
          >
            {header}
          </MuiTypography>
          <MuiBox
            className={`participant-info-card-icon participant-info-card-icon-${type}`}
          >
            <img src={icon} alt=""></img>
          </MuiBox>
        </MuiBox>
        <MuiBox display="flex" justifyContent="space-between" alignItems="end">
          <MuiBox>
            <MuiTypography variant="body2Bold">{count}</MuiTypography>
            <MuiBox>
              <MuiTypography
                variant="h5SemiBold"
                className="participant-info-card-header"
              >
                {label}
              </MuiTypography>
            </MuiBox>
          </MuiBox>
          <MuiBox>
            <ArrowForwardRoundedIcon color="primary" />
          </MuiBox>
        </MuiBox>
      </MuiBox>
    </ManageParticipantsInfoCardStyle>
  );
};
